var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.isLiked ? 'text-danger' : 'text-muted',on:{"click":_vm.toggle}},[(_vm.isLiked)?[_c('i',{staticClass:"fas fa-heart"})]:[_c('i',{staticClass:"far fa-heart"})],_vm._v("\n  "+_vm._s(_vm.count ? _vm.count : '')+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }